import {
  MinusCircleOutlined,
  SyncOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
} from '@ant-design/icons';

import { Default, Blue, Orange, Green } from 'components/tag/StatusColorConfig';

import { StatusConfig } from 'types/tag/StatusConfigType';
import { StatusType } from 'types/tag/StatusType';

export const CLOSE_STATUS_CONFIG: Partial<Record<StatusType, StatusConfig>> = {
  TODO: {
    ...Default,
    icon: <MinusCircleOutlined />,
    title: 'To do',
  },
  IN_PROGRESS: {
    ...Blue,
    icon: <SyncOutlined />,
    title: 'In Progress',
  },
  IN_REVIEW: {
    ...Orange,
    icon: <ExclamationCircleOutlined />,
    title: 'In Review',
  },
  COMPLETED: {
    ...Green,
    icon: <CheckCircleOutlined />,
    title: 'Completed',
  },
};
